import React from "react";

export const EvidenceNode = ({
  label,
  variant = "filled",
  size = 10,
  active = false,
  className = "",
}) => (
  <span className={`evidence-node node-${variant}${active ? " is-active" : ""} ${className}`}>
    <span className="evidence-node-dot" style={{ width: size, height: size }} />
    {label ? <span className="evidence-node-label">{label}</span> : null}
  </span>
);

export default EvidenceNode;
